import { API_JWT_BASE_URL } from '../http'

export const SEARCH_GROUP_API = `${API_JWT_BASE_URL}/Groups/search`
export const GET_GROUP_DETAIL_API = `${API_JWT_BASE_URL}/Groups/details/`
export const GET_GROUP_IS_GENERATING_API = `${API_JWT_BASE_URL}/Groups/isgroupingenerating`
export const GET_GROUP_CREATION_INFO_API = `${API_JWT_BASE_URL}/Groups/getgroupcreationinfo`
export const GET_GROUP_CONFIGURATION_COLUMNS_API = `${API_JWT_BASE_URL}/Groups/getconfigurationcolumns`
export const CREATE_GROUP_API = `${API_JWT_BASE_URL}/Groups`
export const UPDATE_GROUP_API = `${API_JWT_BASE_URL}/Groups/`
export const DETELE_GROUP_API = `${API_JWT_BASE_URL}/Groups`
export const EXPORT_SERIAL_NUMBER_API = `${API_JWT_BASE_URL}/Groups/exportserialnumbers`
export const EXPORT_MISSING_LICENSE_KEYS_API = `${API_JWT_BASE_URL}/Groups/exportmisinglicensekeys`
export const GET_OTAP_SUMMARY_API = `${API_JWT_BASE_URL}/Groups/getotapsummary`
export const GET_SIMPLEGROUPS_API = `${API_JWT_BASE_URL}/Groups/simpleGroups`

export const GROUP_QUERY_KEYS = {
  SEARCH_GROUP_API: 'SEARCH_GROUP_API',
  GET_ALL_GROUP: 'GET_ALL_GROUP',
  GET_GROUP_DETAIL: 'GET_GROUP_DETAIL',
  GET_GROUP_IS_GENERATING: 'GET_GROUP_IS_GENERATING',
  GET_GROUP_CREATION_INFO: 'GET_GROUP_CREATION_INFO',
  GET_GROUP_CONFIGURATION_COLUMNS: 'GET_GROUP_CONFIGURATION_COLUMNS',
  CREATE_GROUP: 'CREATE_GROUP',
  UPDATE_GROUP: 'UPDATE_GROUP',
  DETELE_GROUP: 'DETELE_GROUP',
  EXPORT_SERIAL_NUMBER: 'EXPORT_SERIAL_NUMBER',
  GET_OTAP_SUMMARY: 'GET_OTAP_SUMMARY',
  GET_SIMPLEGROUPS: 'GET_SIMPLEGROUPS'
}
